import type {ThreadRecord} from '@reados/contracts';

/** Explicit server identity wins; local IDs cover an unsent or legacy local quick chat only. */
export function withLocalQuickChats(threads:ThreadRecord[],localIds:readonly string[]):ThreadRecord[]{
 const marked=new Set(localIds);
 return threads.map(thread=>!thread.quickChat&&marked.has(thread.id)?{...thread,quickChat:{}}:thread);
}
export function conversationParent(thread:ThreadRecord):string|undefined{
 return thread.quickChat?thread.quickChat.parentThreadId:thread.forkedFromThreadId;
}
export function conversationTitle(thread:ThreadRecord):string{
 if(thread.quickChat)return thread.quickChat.selectionPreview?.trim()?`“${thread.quickChat.selectionPreview.trim()}”`:'快捷问答';
 return thread.title||'新对话';
}
/** Keep only explicitly identified quick chats and their known ancestors, preserving catalog order. */
export function quickChatSources(threads:ThreadRecord[]):ThreadRecord[]{
 const byId=new Map(threads.map(thread=>[thread.id,thread])),keep=new Set<string>();
 for(const thread of threads){
  if(!thread.quickChat)continue;
  let current:ThreadRecord|undefined=thread;
  while(current&&!keep.has(current.id)){keep.add(current.id);const parent=conversationParent(current);current=parent?byId.get(parent):undefined;}
 }
 return threads.filter(thread=>keep.has(thread.id));
}
export function fullConversationTime(value:string|null|undefined):string{
 if(!value)return '暂无记录';
 const date=new Date(value);if(!Number.isFinite(date.getTime()))return '暂无记录';
 return new Intl.DateTimeFormat('zh-CN',{year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(date);
}

/** Details follow the exact direct source, including deletion/restore, without refetching for unrelated catalog edits. */
export function conversationDetailsKey(thread:ThreadRecord,threads:ThreadRecord[],scopeKey:string,attempt:number):string{
 const sourceId=conversationParent(thread),source=sourceId?threads.find(value=>value.id===sourceId):undefined;
 return JSON.stringify([scopeKey,thread.id,thread.updatedAt,thread.lastConversationAt,sourceId??null,source?[source.id,source.title,conversationTitle(source)]:null,attempt]);
}
